export default __webpack_public_path__ + "static/media/884.7d49aba7.gif";